import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { BoolColumn } from '../../components/DataTable/BoolColumn';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { Menu } from '../../interfaces/Menu/Menu';
import { paginateRows } from '../../utils/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';
import { ButtonColumn } from '../../components/DataTable/ButtonColumn';

const columns: TableColumn<Menu>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'name',
    name: 'İsim',
    accessor: (row) => <TextColumn value={row.name} />,
  },
  {
    id: 'is-active',
    name: 'Durum',
    accessor: (row) => <BoolColumn value={row.isActive} />,
    align: 'center',
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type MenusTableProps = {
  menus: Menu[];
  onClickRow: (menu: Menu) => void;
  onDeleteRow: (menu: Menu) => void;
};

export const MenusTable = (props: MenusTableProps) => {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const itemsColumn: TableColumn<Menu> = {
    id: 'items',
    name: 'Ögeler',
    align: 'center',
    accessor: (row) => (
      <ButtonColumn
        label='Düzenle'
        onClick={() => navigate(`/visual/menus/${row.id}`)}
      />
    ),
  };

  const deleteColumn: TableColumn<Menu> = {
    id: 'delete',
    name: 'Sil',
    align: 'center',
    accessor: (row) => (
      <ButtonColumn label='Sil' onClick={() => props.onDeleteRow(row)} />
    ),
  };

  const paginatedRows = useMemo(
    () => paginateRows(props.menus, limit, page),
    [props.menus, limit, page],
  );

  return (
    <DataTable
      columns={[...columns, itemsColumn, deleteColumn]}
      totalCount={props.menus.length}
      rows={paginatedRows}
      limit={limit}
      setLimit={setLimit}
      page={page}
      setPage={setPage}
      onClick={props.onClickRow}
    />
  );
};
